// Botons d'accés ràpid (Arxius, Factures) per a un contracte; usat per ContratoDetail.
import { Dropdown, DropdownButton, Button } from "react-bootstrap";
import { LuFiles, LuFileUp } from "react-icons/lu";
import { FaFileInvoiceDollar } from "react-icons/fa";

export default function ContratosListActions({
    contrato,
    onGestionArchivos,
    onSubirArchivo,
    onGestionFacturas,
}) {
    return (
        <div className="d-flex flex-wrap gap-2">
            <Button
                variant="light"
                size="sm"
                className="rounded-pill px-3 fw-bold shadow-sm border d-flex align-items-center gap-2"
                onClick={() => onGestionArchivos(contrato.id, contrato.name, contrato.sector_type)}
            >
                <LuFiles /> Archivos
            </Button>



            <Button
                variant="light"
                size="sm"
                className="rounded-pill px-3 fw-bold shadow-sm border d-flex align-items-center gap-2"
                onClick={() => onGestionFacturas(contrato.id, contrato.name, contrato.sector_type)}
            >
                <FaFileInvoiceDollar /> Facturas
            </Button>
        </div>
    );
}
